module.exports = __webpack_public_path__ + "img/Dashboard.7629cf6e.png";